import {
    AuthenticationResponse,
    ChangeUserAccountResponse,
    UsersListResponse,
    UserAccountsResponse,
} from "../../profileTypes"
import { AuthenticationAction } from "../../../login/loginTypes"

export function isChangeUserAccountResponse(response?: ChangeUserAccountResponse): response is AuthenticationResponse {
    return (response as AuthenticationResponse).authenticationResult !== undefined
}

export function isUserTypeResponse(response?: ChangeUserAccountResponse): response is UsersListResponse {
    return (response as UsersListResponse).userTypes !== undefined
}

export function needsEmailConfirmation(response?: UserAccountsResponse): boolean {
    return response?.authenticationResult?.action === AuthenticationAction.APPROVE_ACCOUNT_FROM_URL
}

